import ErrorPrompt from './ErrorPrompt';
import './style/index.less';

export default ErrorPrompt;
